import { useEffect } from "react";
import { setAttribute, unsetAttribute } from "../../services/monitoring";

export default function useMonitoringAttribute(key, val) {
  useEffect(() => {
    if (val !== null && val !== undefined) {
      setAttribute(key, val);
    }
    return () => unsetAttribute(key);
  }, [key, val]);
}
